module.exports = __webpack_public_path__ + "img/1482406262.19621077.jpg";